// libs
import * as React from 'react'

// components
import { Auth } from 'src/components/authentication/auth/auth'

const LoginPage: React.FC = () => (
  <Auth closeModal={() => undefined} closeable={false} />
)

export default LoginPage
